export const INITIAL_OPTIONS_LIMIT = 100
export const SEARCH_DEBOUNCE_MS = 300
export const MAX_SELECTION_LIMIT = 600
export const SEARCH_REQUIRED_THRESHOLD = 200

export const warningColors = {
  atLimit: '#F44336',
  nearLimit: '#E65100',
}
